"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FunctionName;
(function (FunctionName) {
    FunctionName["SUM"] = "SUM";
    FunctionName["AVG"] = "AVG";
    FunctionName["MAX"] = "MAX";
    FunctionName["MIN"] = "MIN";
    FunctionName["COUNT"] = "COUNT";
    FunctionName["STDDEV"] = "STDDEV";
    FunctionName["VARIANCE"] = "VAR";
    FunctionName["BY_SECOND"] = "BY_SECOND";
    FunctionName["BY_MINUTE"] = "BY_MINUTE";
    FunctionName["HOURLY"] = "HOURLY";
    FunctionName["DAILY"] = "DAILY";
    FunctionName["WEEKLY"] = "WEEKLY";
    FunctionName["MONTHLY"] = "MONTHLY";
    FunctionName["QUARTERLY"] = "QUARTERLY";
    FunctionName["YEARLY"] = "YEARLY";
    FunctionName["BY_DECADE"] = "BY_DECADE";
    FunctionName["BY_CENTURY"] = "BY_CENTURY";
    FunctionName["BY_MILLENIUM"] = "BY_MILLENIUM";
    FunctionName["BY_MILLISECOND"] = "BY_MILLISECOND";
    FunctionName["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    FunctionName["NONE"] = "NONE";
    /*
    public boolean isDateRelated() {
      switch (this) {
        case BY_CENTURY:
        case BY_DECADE:
        case BY_MILLENIUM:
        case BY_MILLISECOND:
        case BY_MINUTE:
        case BY_SECOND:
        case DAILY:
        case HOURLY:
        case MONTHLY:
        case QUARTERLY:
        case WEEKLY:
        case YEARLY:
          return true;
        default:
          return false;
      }
    }
  
      public boolean isAggregation() {
      switch (this) {
        case COUNT:
        case SUM:
        case AVERAGE:
        case VAR:
        case STDDEV:
        case MIN:
        case MAX:
          return true;
        default:
          return false;
      }
    }
    */
})(FunctionName || (FunctionName = {}));
exports.default = FunctionName;
//# sourceMappingURL=FunctionName.js.map


//////////////////
// WEBPACK FOOTER
// ../api/lib/abstract_query/interfaces/FunctionName.js
// module id = 387
// module chunks = 8